import css from './WalletExtra.module.scss'
import React, { useEffect, useRef, useState } from 'react'
import MediaQuery from 'react-responsive'

import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { Grid, GridContainer } from 'components/Layout/Grid'
import useOnScreen from 'components/Pages/Collection/InfoBox/Gallery/Images/Item/useOnScreen'

import Divider from '../Divider'
import { WalletTicketDesktopSkeleton } from '../WalletTickets/WalletTicketDesktop'
import { WalletTicketMobileSkeleton } from '../WalletTickets/WalletTicketMobile'
import WalletExtraDesktopContainer from './WalletExtraDesktop/WalletExtraDesktopContainer'
import WalletExtraMobileContainer from './WalletExtraMobile/WalletExtraMobileContainer'

interface Props {
  pastGoodsServices: IWalletEvent[]
  upcomingGoodsServices: IWalletEvent[]
  eventActive: number | null
  useLongCard: boolean
  setEventActive(eventId: number): void
  setUseLongCard(value: boolean): void
  setPastGoodsServicesVisible(value: boolean): void
}

const WalletExtra: React.FC<Props> = (props) => {
  const [isActiveExtraUsable, setIsActiveExtraUsable] = useState<boolean | null>(null)

  const [isThereAtLeastOneUpcomingExtra, setIsThereAtLeastOneUpcomingExtra] = useState<boolean>(false)
  const [isThereAtLeastOneUsableExtra, setIsThereAtLeastOneUsableExtra] = useState<boolean>(false)

  const {
    pastGoodsServices,
    upcomingGoodsServices,
    eventActive,
    useLongCard,
    setEventActive,
    setUseLongCard,
    setPastGoodsServicesVisible,
  } = props

  const pastEventsRef = useRef<HTMLDivElement>(null)
  const arePastEventsVisible = useOnScreen(pastEventsRef)

  useEffect(() => {
    if (arePastEventsVisible) {
      setPastGoodsServicesVisible(true)
    }
  }, [arePastEventsVisible])

  return (
    <>
      <MediaQuery maxWidth={BreakpointsMaxWidth.laptop}>
        {!eventActive && isThereAtLeastOneUsableExtra && <Divider type="usable" />}

        {!upcomingGoodsServices && [0, 1, 2].map((item) => <WalletTicketMobileSkeleton key={item} />)}
        {upcomingGoodsServices &&
          pastGoodsServices &&
          !pastGoodsServices.some((e) => e.id === eventActive) &&
          ((eventActive && isActiveExtraUsable) || !eventActive) && (
            <GridContainer className={css.tickets} style={{ height: eventActive ? (useLongCard ? 830 : 652) : 'auto' }}>
              {upcomingGoodsServices.map((eventData) => (
                <WalletExtraMobileContainer
                  key={eventData.id}
                  onClick={(eventId) => {
                    setEventActive(eventId)
                    setIsActiveExtraUsable(true)
                    setUseLongCard(true)
                  }}
                  //@ts-ignore
                  eventActive={eventActive}
                  useLongCard={useLongCard}
                  walletEventData={eventData}
                  setIsThereAtLeastOne={setIsThereAtLeastOneUsableExtra}
                  isUsable
                />
              ))}
            </GridContainer>
          )}

        {!eventActive && isThereAtLeastOneUpcomingExtra && <Divider type="upcoming" />}

        {!upcomingGoodsServices && [0, 1, 2].map((item) => <WalletTicketMobileSkeleton key={item} />)}
        {upcomingGoodsServices &&
          pastGoodsServices &&
          !pastGoodsServices.some((e) => e.id === eventActive) &&
          ((eventActive && !isActiveExtraUsable) || !eventActive) && (
            <GridContainer className={css.tickets} style={{ height: eventActive ? (useLongCard ? 830 : 652) : 'auto' }}>
              {upcomingGoodsServices.map((eventData) => (
                <WalletExtraMobileContainer
                  key={eventData.id}
                  onClick={(eventId) => {
                    setEventActive(eventId)
                    setIsActiveExtraUsable(false)
                    setUseLongCard(true)
                  }}
                  //@ts-ignore
                  eventActive={eventActive}
                  useLongCard={useLongCard}
                  walletEventData={eventData}
                  setIsThereAtLeastOne={setIsThereAtLeastOneUpcomingExtra}
                />
              ))}
            </GridContainer>
          )}

        {!eventActive && pastGoodsServices && pastGoodsServices.length > 0 && <Divider type="past" />}

        {!pastGoodsServices && [0, 1, 2].map((item) => <WalletTicketMobileSkeleton key={item} />)}
        {pastGoodsServices && upcomingGoodsServices && !upcomingGoodsServices.some((e) => e.id === eventActive) && (
          <GridContainer className={css.tickets} style={{ height: eventActive ? (useLongCard ? 830 : 652) : 'auto' }}>
            <div ref={pastEventsRef} />
            {pastGoodsServices.map((eventData) => (
              <WalletExtraMobileContainer
                key={eventData.id}
                onClick={(eventId) => {
                  setEventActive(eventId)
                  setUseLongCard(true)
                }}
                //@ts-ignore
                eventActive={eventActive}
                useLongCard={useLongCard}
                walletEventData={eventData}
                isPastEvent
              />
            ))}
          </GridContainer>
        )}
      </MediaQuery>

      <MediaQuery minWidth={BreakpointsMaxWidth.laptop}>
        {isThereAtLeastOneUsableExtra && <Divider type="usable" />}
        <GridContainer>
          <Grid className={css.tickets}>
            {!upcomingGoodsServices && [0, 1, 2].map((item) => <WalletTicketDesktopSkeleton key={item} />)}
            {upcomingGoodsServices &&
              upcomingGoodsServices.length > 0 &&
              upcomingGoodsServices.map((event, key) => (
                <WalletExtraDesktopContainer
                  key={key}
                  walletEventData={event}
                  isUsable
                  setIsThereAtLeastOne={setIsThereAtLeastOneUsableExtra}
                />
              ))}
          </Grid>
        </GridContainer>
        {isThereAtLeastOneUpcomingExtra && <Divider type="upcoming" />}
        <GridContainer>
          <Grid className={css.tickets}>
            {!upcomingGoodsServices && [0, 1, 2].map((item) => <WalletTicketDesktopSkeleton key={item} />)}
            {upcomingGoodsServices &&
              upcomingGoodsServices.length > 0 &&
              upcomingGoodsServices.map((event, key) => (
                <WalletExtraDesktopContainer
                  key={key}
                  walletEventData={event}
                  setIsThereAtLeastOne={setIsThereAtLeastOneUpcomingExtra}
                />
              ))}
          </Grid>
        </GridContainer>
        {pastGoodsServices && pastGoodsServices.length > 0 && <Divider type="past" />}
        <GridContainer>
          <div ref={pastEventsRef} />
          <Grid className={css.tickets}>
            {!pastGoodsServices && [0, 1, 2].map((item) => <WalletTicketDesktopSkeleton key={item} />)}
            {pastGoodsServices &&
              pastGoodsServices.length > 0 &&
              pastGoodsServices.map((event, key) => (
                <WalletExtraDesktopContainer key={key} walletEventData={event} isPastEvent />
              ))}
          </Grid>
        </GridContainer>
      </MediaQuery>
    </>
  )
}

export default WalletExtra
